import { ValidatorFn, AbstractControl } from '@angular/forms';
import { MultiField } from '@shared/models/multi-field';

export class CassValidators {
	static imageRequired(multiFieldVM: MultiField): ValidatorFn {
		return (): { [key: string]: any } | null => {
			if (!multiFieldVM || (multiFieldVM.config.required && !multiFieldVM.content)) {
				return {
					"cassImageRequired": true
				};
			};
			return null;
		};
	}

	static cassRequiredTrue(translationKey: string, interpolateParams?: Object): ValidatorFn {
		return (control: AbstractControl): { [key: string]: any } | null => {
			if (control.value !== true) {
				return CassValidators.createCassGenericError(translationKey, interpolateParams);
			}
			return null;
		}
	}

	static createCassGenericError(translationKey: string, interpolateParams?: Object): Object {
		return {
			"cassGenericValidationError": {
				"translationKey": translationKey,
				"interpolateParams": interpolateParams
			}
		};
	}
}
